import React, {Component} from 'react';
import {Map,Marker, Popup,TileLayer} from 'react-leaflet';

 export class Location extends Component {

    render () {

        const position = [51.1038, 3.6405];
        const map = (
            <Map center={position} zoom={13}>
                <TileLayer
                    url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                />
                <Marker position={position}>
                    <Popup>
                        <span>KidLogic Smartcitizen Kit</span>
                    </Popup>
                </Marker>
            </Map>
        )

        return (
            <div className="row">
                <div className="col-sm-12">
                    <h1>Sensor Location</h1>
                    {map}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Location.js